export default __webpack_public_path__ + "resources/icons/n320-fad0.webp";